var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input1",attrs:{"placeholder":"Zip/Postal Code","size":"10","type":"text","maxlength":this.country == 'US' ? 5 : 7},on:{"input":function($event){return _vm.validateCode($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }